import Button from '../../app/design/Button'
import Card from '../../app/design/Card'
import Heading from '../../app/design/Heading'
import Paragraph from '../../app/design/Paragraph'
import { FieldIds, NPSStepId, NPSStepProps, StepIds } from './types'
import { NPSWorkflowStep } from './useNPSFormWorkflowCoordinator'

export const CONFIRM_CONTINUE_STEP = {
    id: StepIds.CONFIRM_CONTINUE,
    valuesOnNext: {
        [FieldIds.CONFIRM_CONTINUE]: true,
    },
    shouldShowFooter: false,
    isCentered: true,
} as const satisfies NPSWorkflowStep<NPSStepId>

export function NPSStepConfirmContinuePage(props: NPSStepProps) {
    const {
        next,
        isSaving,
        isTransitioning,
        recordForm: { getField },
    } = props

    return (
        <Card className="p-0">
            <div className="align-center bg-warning-100 flex h-60 justify-center overflow-hidden">
                <img className="h-80" src="/icons/message-card-boss.svg" />
            </div>
            <div className="p-8 text-center">
                <Heading size="xl" className="mb-4">
                    Have 2 minutes?
                </Heading>
                <Paragraph size="md" className="mb-8 text-gray-600">
                    {getField(FieldIds.CONFIRM_CONTINUE)!.label!}
                </Paragraph>
                <Button
                    intent="primary"
                    className="w-full"
                    onClick={next}
                    isLoading={isSaving}
                    disabled={isTransitioning}
                >
                    Next
                </Button>
            </div>
        </Card>
    )
}
